'use strict';

class AdaWidget {
	constructor(options) {
		this.o = {
			api_key: null
		};
		this.ada_button = document.getElementById('enable_ada_trigger');

		Object.assign(this.o, options);

		this.widget_loaded = false;
		this.ada_button.classList.add('location5');

		for (let i = 0;i < 40;i++) {
			const key = `userway-s${i}`;
			let value = localStorage.getItem(key);
			if (value !== null) {
				if (value === 'false') {
					value = false;
				} else if (value === 'true') {
					value = true;
				} else {
					value = parseInt(value);
				}

				if (value) {
					this.loadWidget();
					break;
				}
			}
		}
		this.ada_button.addEventListener('click', e => {
			e.preventDefault();

			this.loadWidget(true);
		});
	}

	removeFooterInert() {
		const footer_inert = document.querySelector("footer[inert]");
		if (footer_inert) footer_inert.removeAttribute('inert')
	}

	loadWidget(simulate_click = false) {
		const _that = this;
		if (!_that.widget_loaded) {
			_that.widget_loaded = true;

			const s = document.createElement('script');
			s.setAttribute('data-account', _that.o.api_key);
			s.setAttribute('data-position', '5');
			let load_attempts = 0;
			s.onload = () => {
				let retry_interval = setInterval(() => {
					let final_state = false;
					const uw_sl = document.getElementById('userwayAccessibilityIcon');

					if (uw_sl) {
						final_state = true;
					}
					if (load_attempts > 50) {
						final_state = true;
					}
					if (final_state) {
						_that.ada_button.remove();
						clearInterval(retry_interval);

						const uw_sl_parent = uw_sl.closest('.uwy');
						document.querySelector('.footer-content-widgets').insertAdjacentElement('afterbegin', uw_sl_parent);

						// [inert] attribute is added by widget on parent element which also affects the widget itself
						_that.removeFooterInert();
						if (uw_sl) {
							const uw_mobile = uw_sl.closest('.uwy.umb');
							const event_type = uw_mobile ? 'touchstart' : 'click';
							uw_sl.addEventListener(event_type, function() {
								_that.removeFooterInert();
							});
						}
					}

					load_attempts++;
				}, 100);
			};
			s.onerror = () => {
				_that.widget_loaded = false;
			};
			s.setAttribute('src', 'https://cdn.userway.org/widget.js');
			(document.body || document.head).appendChild(s);

			document.addEventListener('userway:init_completed', function (event) {
				if (simulate_click) {
					var instance = event.detail.userWayInstance
					instance.widgetOpen()
				}
			})
		}
	}
}